<template>
    <router-view/>
</template>
<script>
export default {
    name: 'Window',
    data()
    {
        return {
        }
    },
    mounted()
    {
        return Fx.Http.post("/system/user/GetPermissions").
        then((response)=>
        {
            console.log('window permissions:', response);
            this.$store.commit('session/setUserPermissionIdList', response.getData("userPermissionIdList"));
            this.$store.commit('session/setUserPermissionGroupIdList', response.getData("userPermissionGroupIdList"));
        });
    }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/modules/common/pages/Window.vue